import { Layout, Button } from "antd";
import { useNavigate } from "react-router-dom";
import SvgLogo from "../../assets/SvgLogo";
import useUsuario from "../../../core/hooks/UseUsuario";
import { useEffect, useState } from "react";
import AuthorizationService from "../../auth/Authorization.service";
import { TestClock } from "../../components/TestClock/TestClock";
import { MenuOutlined } from "@ant-design/icons";

const { Header } = Layout;

interface HeaderProps {
  onToggleSidebar: () => void;
  onFinish?: () => void;
}

export default function SimuladoHeader({ onToggleSidebar, onFinish }: HeaderProps) {
  const { usuario } = useUsuario();

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

  useEffect(() => {
    if (isMobile) onToggleSidebar();
  }, []);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 767);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Header
      style={{ paddingInline: "16px", height: "auto", lineHeight: "normal", flexShrink: 0 }}
      className="flex items-center justify-between gap-2 py-2 flex-wrap"
    >
      {/* Left: logo + title + sidebar toggle */}
      <div className="flex items-center gap-2 min-w-0">
        <div style={{ width: 36, height: 36, flexShrink: 0 }}>
          <SvgLogo />
        </div>
        <span className="text-white font-semibold text-sm sm:text-base truncate hidden xs:block sm:block">
          Acertei — Simulado
        </span>
        <Button
          type="text"
          icon={<MenuOutlined style={{ color: "white", fontSize: 18 }} />}
          onClick={onToggleSidebar}
          className="ml-1"
        />
      </div>

      {/* Center: clock */}
      <div className="flex-1 flex justify-center">
        <TestClock time="00:00:00" tone="dark" />
      </div>

      {/* Right: validity (desktop only) + finish + logout */}
      <div className="flex items-center gap-3">
        {usuario?.validUntil && (
          <span className="text-white text-xs hidden md:block">
            Válido até{" "}
            <strong>{new Date(usuario.validUntil).toLocaleDateString("pt-BR")}</strong>
          </span>
        )}

        <Button type="primary" size="small" onClick={onFinish}>
          Finalizar
        </Button>

        <span className="text-white text-xs hidden sm:block">
          <span
            className="cursor-pointer underline"
            onClick={() => AuthorizationService.logoutAndRedirect()}
          >
            Sair
          </span>
        </span>
      </div>
    </Header>
  );
}
